import { render, staticRenderFns } from "./VendorProducts.vue?vue&type=template&id=be03292c&scoped=true&"
import script from "./VendorProducts.vue?vue&type=script&lang=js&"
export * from "./VendorProducts.vue?vue&type=script&lang=js&"
import style0 from "./VendorProducts.vue?vue&type=style&index=0&id=be03292c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be03292c",
  null
  
)

export default component.exports